import { render, staticRenderFns } from "./saved-leads.vue?vue&type=template&id=7cb8db98&scoped=true"
import script from "./saved-leads.vue?vue&type=script&lang=js"
export * from "./saved-leads.vue?vue&type=script&lang=js"
import style0 from "./saved-leads.vue?vue&type=style&index=0&id=7cb8db98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb8db98",
  null
  
)

export default component.exports